(function () {
  var iframeName = 'shopify-email-signup-frame';
  var iframe = null;

  function getIframe() {
    if (iframe && iframe.parentNode) return iframe;
    iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.setAttribute('hidden', '');
    iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(iframe);
    return iframe;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.tagName !== 'FORM' || !form.closest('[data-email-signup]')) return;

    e.preventDefault();
    e.stopPropagation();

    var block = form.closest('[data-email-signup]');
    var inputGroup = block.querySelector('[data-email-signup-input-group]');
    var successEl = block.querySelector('.email-signup__message--success');
    var errorEl = block.querySelector('.email-signup__message--error');
    if (!inputGroup || !successEl) return;

    var btn = form.querySelector('button[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('email-signup__button--loading');
    }
    errorEl.classList.add('email-signup__message--hidden');

    var frame = getIframe();
    form.setAttribute('target', iframeName);

    function onLoad() {
      frame.removeEventListener('load', onLoad);
      form.removeAttribute('target');

      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('email-signup__button--loading');
      }

      var hasError = false;
      try {
        var doc = frame.contentDocument || frame.contentWindow.document;
        var body = doc.body ? doc.body.innerText || doc.body.textContent || '' : '';
        if (body.indexOf('already been taken') !== -1 || body.indexOf('invalid') !== -1 || doc.querySelector('.form-status--error')) {
          hasError = true;
        }
      } catch (err) {}

      if (hasError) {
        var errText = errorEl.querySelector('.email-signup__error-text');
        if (errText) errText.textContent = 'Please check your email or try again.';
        errorEl.classList.remove('email-signup__message--hidden');
      } else {
        var custom = successEl.getAttribute('data-success-text');
        var fallback = successEl.getAttribute('data-success-fallback');
        var textEl = successEl.querySelector('.email-signup__message-text');
        if (textEl) textEl.textContent = (custom && custom.length) ? custom : fallback;
        successEl.classList.remove('email-signup__message--hidden');
      }
    }

    frame.addEventListener('load', onLoad);
    form.submit();
    return false;
  }, true);
})();
